export const devMode = process.env.NODE_ENV === 'development'
